import _extends from "@babel/runtime/helpers/extends";
import { MessageModalLayout } from '@wix/design-system';
import React from 'react';
export const buildStudioDialogProps = (messageModalLayoutProps, dialogOptions, shouldCloseOtherDialogs) => {
  const defaultDialogOptions = {
    modal: true,
    modalOptions: {
      backdrop: true,
      closeOnClickOutside: false
    }
  };
  const {
    onCloseButtonClick,
    primaryButtonOnClick,
    secondaryButtonOnClick,
    ...otherProps
  } = messageModalLayoutProps;
  const dialogComponent = closeDialog => /*#__PURE__*/React.createElement(MessageModalLayout, _extends({}, otherProps, {
    primaryButtonOnClick: () => {
      closeDialog('buttonClick');
      primaryButtonOnClick == null || primaryButtonOnClick();
    },
    secondaryButtonOnClick: () => {
      closeDialog('closeDialogClick');
      secondaryButtonOnClick == null || secondaryButtonOnClick();
    },
    onCloseButtonClick: event => {
      closeDialog('closeDialogClick');
      onCloseButtonClick == null || onCloseButtonClick(event);
    }
  }));
  return [dialogComponent, {
    ...defaultDialogOptions,
    zIndex: 1155,
    // ensure dialog does not overlay help/KB modal
    ...dialogOptions
  }, shouldCloseOtherDialogs];
};
//# sourceMappingURL=build-studio-dialog-props.js.map